import React from 'react';
import styled from '@emotion/styled';
import WYPBannerIcon from './icons/WYPBannerIcon';
import PrimaryButton from '../../atoms/buttons/PrimaryButton';
import { isDarkMode } from '../../utils/helpers';
import backgrounds from '../../theme/backgrounds';
import RoundDismissIcon from '../../atoms/icons/RoundDismissIcon';
import { trackPWaMixpanelEventInstalled } from '../../utils/pwa';
import borders from 'theme/borders';

const PromptContainer = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    backgroundColor: backgrounds[theme].blue,
    borderRadius: 10,
    border: `1px solid ${borders[theme].primary}`,
    padding: 15,
    margin: '-10px 10px 10px 10px',
  };
});

const BannerLogoActions = styled('div')({
  textAlign: 'right',
  marginTop: 10,
});

const SidebarBannerTitle = styled('p')(() => ({
  fontSize: 15,
  fontWeight: 600,
  lineHeight: '18px',
  color: isDarkMode() ? '#F6F4F4' : '#333',
  padding: 0,
  margin: 0,
  letterSpacing: '-0.16px',
}));

const BannerDescription = styled('p')(() => ({
  fontSize: 13,
  fontWeight: 400,
  color: isDarkMode() ? '#AFB0B1' : '#595959',
  padding: 0,
  margin: 0,
  marginTop: 10,
  lineHeight: '18px',
  letterSpacing: '-0.14px',
}));

const PWABannerLogoTextWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

const BannerTextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '80%',
  marginLeft: 10,
});

const CloseButtonContainer = styled('div')({
  width: '100%',
  textAlign: 'right',
});

interface PWASidebarBannerContentProps {
  onClick?: any;
  onClose: () => void;
}

const PWAMessagePageBannerContent: React.FC<PWASidebarBannerContentProps> = ({ onClick, onClose }) => {
  return (
    <PromptContainer>
      <CloseButtonContainer>
        <RoundDismissIcon onClick={onClose} />
      </CloseButtonContainer>
      <PWABannerLogoTextWrapper>
        <>
          <WYPBannerIcon customStyle={{ marginTop: '-1%' }} />
        </>
        <BannerTextContainer>
          <SidebarBannerTitle>Get instant notifications on your device</SidebarBannerTitle>
          <BannerDescription>Never miss a message again!</BannerDescription>
        </BannerTextContainer>
      </PWABannerLogoTextWrapper>
      <BannerLogoActions>
        <PrimaryButton
          customStyle={{ width: 'inherit' }}
          data-test-id="pwa-banner-install"
          id="install"
          onClick={() => {
            onClick();
            trackPWaMixpanelEventInstalled('Message');
          }}
          label="Install the App"
          size="small"
          color="red"
        />
      </BannerLogoActions>
    </PromptContainer>
  );
};

export default PWAMessagePageBannerContent;
